import React from 'react';
import AboutSide from '../../components/aboutSide/AboutSide';

const About = () => (
    <>
        <AboutSide />
    </>
);

export default About;